// extracted by mini-css-extract-plugin
module.exports = {"M":"companyInfo_M__27rfS","CompanyInfo":"companyInfo_CompanyInfo__17Wn5"};